import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import fraRatings from "../../../../src/data/articles/cube-prospective-reality-fracture/fra-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  fraRatings,
  ProspectiveIntro,
  React
};